import React from "react";
import { ReactComponent as OpenAllIcon } from "../../../pages/styles/Images/openFastIcon.svg";
import { ReactComponent as OpenModelsIcon } from "../../../pages/styles/Images/openModelIcon.svg";
import { ReactComponent as UploadFileIcon } from "../../../pages/styles/Images/uploadFileIcon.svg";
import { ReactComponent as RenameFileIcon } from "../../../pages/styles/Images/rename.svg";
import { ReactComponent as DeleteFileIcon } from "../../../pages/styles/Images/delete.svg";
import { ReactComponent as ShareIcon } from "../../../pages/styles/Images/icon-share.svg";
import classes from "./FileSystemHeader.module.css";
import { useAppDispatch, useAppSelector } from "../../../app/hooks/hooks";
import { logout, selectUser } from "../../../app/features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import MenuButton from "../../Buttons/MenuButton";
import { useDeleteFileMutation } from "../../../app/services/files/files";
interface FileSystemHeaderProps {
    uploadFileCallback: any;
    openCallback: any;
    openAllCallback: any;
    shareLinkCallback: any;
    selectedState: { [model_id: string]: number };
    refetch: () => void;
}
function FileSystemHeader({
    uploadFileCallback,
    openCallback,
    openAllCallback,
    shareLinkCallback,
    selectedState,
    refetch,
}: FileSystemHeaderProps) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const currentUser = useAppSelector(selectUser);
    const [deleteFile] = useDeleteFileMutation();
    const renameFileHandle = () => {};
    const deleteFileHandle = () => {
        for (const model_id of Object.keys(selectedState)) {
            deleteFile(model_id).unwrap().then(refetch);
        }
    };

    return (
        <div className={classes.wrap}>
            {currentUser ? (
                <div className={classes.logout_wrap}>
                    <div className={classes.email}>{currentUser.email}</div>
                    <MenuButton
                        className={classes.logout_but}
                        onClick={() => {
                            dispatch(logout());
                        }}
                    >
                        Выйти
                    </MenuButton>
                </div>
            ) : (
                <MenuButton
                    className={classes.login_wrap}
                    onClick={() => {
                        navigate("/login");
                    }}
                >
                    login
                </MenuButton>
            )}

            <div className={classes.button_wrap}>
                {Object.keys(selectedState).length ? (
                    <>
                        <div title="Share models">
                            <ShareIcon
                                onClick={shareLinkCallback}
                                className={classes.button_share}
                            ></ShareIcon>
                        </div>
                        <div title="Delete file">
                            <DeleteFileIcon
                                onClick={deleteFileHandle}
                                className={classes.button}
                            ></DeleteFileIcon>
                        </div>
                    </>
                ) : (
                    <></>
                )}
                {/* {Object.keys(selectedState).length === 1 ? (
                    <div title="Rename file">
                        <RenameFileIcon
                            className={classes.button_rename}
                        ></RenameFileIcon>
                    </div>
                ) : (
                    <></>
                )} */}

                <div title="Upload model file">
                    <UploadFileIcon
                        onClick={uploadFileCallback}
                        className={classes.button}
                    ></UploadFileIcon>
                </div>
                <div title="Open selected models">
                    <OpenModelsIcon
                        onClick={openCallback}
                        className={classes.button}
                    ></OpenModelsIcon>
                </div>
                <div title="Open all models">
                    <OpenAllIcon
                        onClick={openAllCallback}
                        className={classes.button}
                    ></OpenAllIcon>
                </div>
            </div>
        </div>
    );
}

export default FileSystemHeader;
